import React from 'react';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { SmallBodyText, TextField } from '../../../../../ui-toolkit';

export const FirstMortgagePayoffAccount: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={'First Mortgage Payoff Account'}
      tab={'other'}
      field={'firstMortgagePayoffAccount'}
      onUpdate={(field, value) => onPatchOrderInformation({ firstMortgagePayoffAccount: value })}
      order={order}
      editControl={TextField}
      editProps={{}}
      data-test-id={'first-mortgage-payoff-account'}
    >
      {order.transaction.firstMortgagePayoffAccount ?? <SmallBodyText intent={'faded'}>-</SmallBodyText>}
    </SummaryItemWithEdit>
  );
};
